<template>
  <div class="header-box">
    <div class="main-body">
      <div class="logo-box">
        <img class="logo-img" src="../../assets/img/index/logo_white.png" alt="">
        <span class="logo-text">开放平台</span>
      </div>
      <ul class="menu-box" v-if="headMenuShow">
        <li v-for="(item, $index) in menuList" :key="$index"
            :class="['menu-item', { 'menu-active': funMenuActive(item)}]"
            @click="goMenuPath(item)">
          <span>{{ item.title }}</span>
          <ul class="menu-child-box" v-if="item.child_node && item.child_node.length">
            <li v-for="(item, $index) in item.child_node" :key="$index"
                :class="['menu-child-item text-ellipsis',
                { 'menu-child-active' : $route.query.menu === item.id.toString() }]"
                @click="goMenuPath(item)">
              <span>{{ item.title }}</span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="opt-box" v-if="headMenuShow">
        <span>
          <el-input size="mini" style="width: 120px;" prefix-icon="el-icon-search"
                    maxlength="30"
                    placeholder="搜索"
                    v-model="searchText"
                    @change="search()"
                    @keyup.enter.native="search()">
          </el-input>
          </span>
        <template v-if="!userInfo.reg_mobile">
          <span :class="['opt-item', {'text-warning': curPath === '/log-in'}]" @click="goLogin">登录</span>
          <span :class="['opt-item', {'text-warning': curPath === '/enroll'}]" @click="goRegister">注册</span>
        </template>
        <template v-else>


          <span :class="['opt-item', 'opt-control', curPath.indexOf('/control') !== -1 ? 'text-warning on' : '']"
                @click="goControl">
            <i class="el-icon-monitor" style="font-size:20px; margin-right: 5px"></i>控制台</span>

          <span :class="['opt-item', 'opt-message', curPath.indexOf('/message') !== -1 ? 'text-warning on' : '']"
                @click="goNotify">
            <el-badge :is-dot="unReadCount !== 0" class="item">
              <i class="el-icon-bell" style="font-size:20px;"></i></el-badge>
            通知</span>
          <div class="opt-user-box">
            <div :class="['opt-user', 'text-ellipsis', {'user-on text-warning': curPath === '/personage'}]">
              <i class="el-icon-user-solid" style="font-size:18px;"></i>
              {{ userInfo.account }}
            </div>
            <i class="opt-user-arrow"></i>

            <div class="user-info-box">
              <img class="info-head f-l" :src="userInfo.head_photo || userImg" alt="">
              <div class="info-text f-l">
                <div class="info-name text-ellipsis">Hi，{{ userInfo.account }}</div>
                <div class="text-ellipsis">
                  <img class="info-img" src="../../assets/img/index/icon_phone.png" alt="">
                  <span class="v-middle">{{ userInfo.reg_mobile }}</span>
                </div>
                <div class="text-ellipsis">
                  <img class="info-img" src="../../assets/img/index/icon_email.png" alt="">
                  <span class="v-middle">{{ userInfo.email }}</span>
                </div>
                <div class="info-btn">
                  <span @click="goPersonage">个人信息</span>
                  <span @click="loginOut">退出</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import userImg from "../../assets/img/index/user_avatar.png";
import {loginPath, registerPath} from "../../assets/js/common";

export default {
    name: "e-header",
    data() {
      return {
        userImg: userImg,
        headMenuShow: false,
        menuList: [],
        searchText: null,
      };
    },
    computed: {

      curPath() {
        return this.$route.path
      },
      userInfo() {
        return this.$store.state.app.userInfo
      },
      unReadCount() {
        return this.$store.state.app.unReadCount
      },
  },
  watch: {
    '$route'() {
      this.headInit()
    }
  },
  mounted() {
    this.headInit();
    if (this.headMenuShow) {
      this.getNav();
    }
  },
  methods: {
    ...mapActions(['clearUserInfo']),
    search(e) {
      let searchText = this.searchText;
      if (searchText !== null && searchText !== undefined && searchText.length > 0) {
        this.$router.push(`/help/search?key=${searchText}`)
        this.searchText = null;
        e.target.blur();
      }
    },
    funMenuActive(item) {
      let childActive = (item.child_node || []).some(val => {
        return val.link_url === this.curPath
      });
      return item.link_url === this.curPath || childActive
    },
    transform(url) {
      if (url.indexOf('http') !== -1) {
        return url.split('#')[url.split('#').length - 1];
      }
      return url;
    },
    getNav() {
      this.$axios.get('/ajax/navigation/tree/list').then(res => {
        this.menuList = res.data.data;
        this.$store.commit('setMenuList', this.getArr(this.menuList));
        this.menuList.map((item, i) => {
          if (item.link_url.indexOf('/generic-doc/5') !== -1) {
            localStorage.setItem("menuPT", item.id)
          }
        });
      });
    },
    headInit() {
      this.headMenuShow = this.$route.meta.userType !== 2
    },
    goLogin() {
      this.$router.push({path: loginPath()})
    },
    goRegister() {
      this.$router.push({path: registerPath()})
    },
    goPersonage() {
      this.$router.push({path: '/personage'})
    },
    goControl() {
      this.$router.push({path: '/control/myapp?sandbox=0'})
    },
    goNotify() {
      this.$router.push({path: '/message/mymessage'})
    },
    goMenuPath(item) {
      if (item.child_node && item.child_node.length) {
        return
      }
      if (!item.link_url) {
        this.$message.warning('地址错误，请联系管理员');
        return
      }
      if (item.target === 1) {
        if (item.link_url.indexOf('http') === -1) {
          let url = this.transform(item.link_url);
          if (this.$route.path === url) {
            return;
          }
          document.title = item.title;
          return this.$router.push({
            path: url,
            query: {
              menu: item.id
            }
          });
        }
        window.location.href = item.link_url;
      } else if (item.target === 2) {
        if (item.link_url.indexOf('http') === -1) {
          window.open(location.origin + location.pathname + '#' + item.link_url);
          return
        }
        window.open(item.link_url);
      }
    },
    loginOut() {
      this.clearUserInfo();
      window.location.href = '/';
    },
    getArr(data, arr) {
      let array = arr || [];
      data.forEach(val => {
        if (val.child_node.length === 0) {
          array.push({
            id: val.id,
            title: val.title,
            link_url: val.link_url
          });
        } else {
          this.getArr(val.child_node, array);
        }
      })
      return array;
    }
  }
};
</script>

<style lang="scss" scoped>

/deep/ .el-input__inner {
  border: 0px;
  color: white;
  background-color: rgba(255, 255, 255, 0.247);
}

.item {
  padding-left:-2px;
  margin-right: 2px;
}

.header-box {
  width: 100%;
  height: 66px;
  background: #424456;
  color: #fff;
  position: fixed;
  z-index: 1000;

  .main-body {
    position: relative;
  }


  .logo-box {
    position: absolute;
    top: 0;
    left: 30px;
    width: 252px;
    padding-top: 20px;
    display: inline-block;

    .logo-img {
      width: 94px;
      height: 28px;
      vertical-align: middle;
    }

    .logo-text {
      height: 28px;
      line-height: 28px;
      font-size: 22px;
      margin-left: 10px;
      padding-left: 10px;
      border-left: 1px solid rgba(255, 255, 255, 0.8);
      vertical-align: middle;
    }
  }

  .menu-box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 0 0 252px;
    box-sizing: border-box;
    white-space: nowrap;

    .menu-item {
      display: inline-block;
      min-width: 70px;
      height: 100%;
      line-height: 60px;
      font-size: 16px;
      padding: 0 15px;
      text-align: center;
      border-top: 3px solid transparent;
      border-bottom: 3px solid transparent;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;

      &:hover {
        .menu-child-box {
          display: block;
        }
      }
    }

    .menu-item:hover,
    .menu-active {
      background: #2A2C44;
      color: #f16622;
      border-top: 3px solid #f16622;
    }

    .menu-child-box {
      display: none;
      position: absolute;
      top: 63px;
      left: 0;
      min-width: 100%;
      max-width: 200%;
      background: #424456;
      z-index: 1;
      word-break: keep-all;
    }

    .menu-child-item {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      padding: 0 15px;
      color: #fff;
      text-align: left;
      box-sizing: border-box;
    }

    .menu-child-item:hover,
    .menu-child-active {
      background: #f16622;
      color: #fff;
    }
  }

  .opt-box {
    position: absolute;
    top: 0;
    right: -970px;
    height: 100%;
    line-height: 22px;
    padding-top: 22px;
    padding-left: 30px;
    padding-right: 1000px; // 给一个足够大的值确保能全部遮挡右侧空白 保证多余的菜单全被遮住 再通过right调到正常的位置
    box-sizing: border-box;
    background: #424456;

    .opt-item {
      padding: 0 8px;
      font-size: 16px;
      cursor: pointer;

      .icon {
        width: 8px;
        height: 8px;
        border-radius: 8px;
        background-color: #f16622;
        vertical-align: middle;
        position: absolute;
        left: 137px;
        top: 26px;
      }
    }

    .opt-control {
      padding: 0 16px 0 5px;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      margin-right: 5px;
      //background: url("../../assets/img/index/icon_control.png") no-repeat left center;
      background-size: 14px 14px;
      vertical-align: middle;
      &.on {
        //background: url("../../assets/img/index/icon_control_on.png") no-repeat left center;
        background-size: 14px 14px;
      }
    }

    .opt-message {
      padding: 0 16px 0 5px;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      margin-right: 5px;
      //background: url("../../assets/img/index/icon_notify.png") no-repeat left center;
      //background-color: red;
      background-size: 14px 14px;
      vertical-align: middle;
      &.on {
        //background: url("../../assets/img/index/icon_notify_on.png") no-repeat left center;
        background-size: 14px 14px;
      }
    }

    .opt-user-box {
      display: inline-block;
      margin-left: 6px;
      vertical-align: middle;
      position: relative;

      &:hover {
        .user-info-box {
          display: block;
        }

        .opt-user-arrow {
          transform: rotate(0);
        }
      }

      &:after {
        content: ''; // 占位 拓展opt-user-box的hover范围 防止间隙时失去hover效果
        position: absolute;
        top: 18px;
        left: 0;
        width: 100%;
        height: 18px;
        background: transparent;
      }
    }

    .opt-user {
      display: inline-block;
      max-width: 100px;
      margin-right: 4px;
      //background: url("../../assets/img/index/icon_head_gray.png") no-repeat left 0;
      background-size: 16px 18px;
      vertical-align: middle;
      cursor: pointer;
      &.user-on {
        //background: url("../../assets/img/index/icon_head.png") no-repeat left 3px;
        background-size: 13px 13px;
        padding-left: 20px;
        margin-left: 8px;
      }
    }

    .opt-user-arrow {
      display: inline-block;
      width: 22px;
      height: 22px;
      margin-left: -8px;
      background: url("../../assets/img/index/icon_arrow_top.png") no-repeat center;
      background-size: 14px 8px;
      vertical-align: middle;
      transform: rotate(-180deg);
      cursor: pointer;
    }
  }

  .user-info-box {
    display: none;
    position: absolute;
    top: 35px;
    right: 6px;
    width: 280px;
    height: 136px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    background: #fff;
    z-index: 1;

    .info-head {
      position: absolute;
      top: 16px;
      left: 16px;
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }

    .info-text {
      width: 100%;
      padding: 16px 16px 10px 105px;
      box-sizing: border-box;
      font-size: 12px;
      color: #9E9E9E;
      line-height: 22px;
    }

    .info-name {
      font-size: 16px;
      color: #000;
      margin-bottom: 6px;
    }

    .info-img {
      width: 16px;
      height: 16px;
      margin-right: 3px;
      vertical-align: middle;
    }

    .info-btn {
      font-size: 14px;
      color: #F16622;
      text-align: right;
      margin-top: 12px;
      padding-right: 10px;
      cursor: pointer;

      span:first-child {
        margin-right: 33px;
      }
    }
  }
}
</style>

<style lang="scss">


/*对h5的兼容*/
@media screen and (max-width: 768px) {
  .h5-components {
    &.main-box {
      min-width: 300px;
    }

    .main-body {
      width: 100%;
      padding: 0 20px;
    }

    .body-content {
      padding: 60px 0 40px;
    }

    .header-box {
      width: 100%;
      height: 60px;
      text-align: center;

      .logo-box {
        padding-top: 18px;
        left: 0;
        width: 100%;
      }
    }
  }

}
</style>




// WEBPACK FOOTER //
// src/components/common/e-header.vue